
import { mapState } from 'vuex'
import dayjs from 'dayjs' // 时间转换
import dealerMt from '@/components/company/v2/dealerMt.vue'
import individuaidentification from '@/components/company/v2/individuaidentification.vue'
import authenticationmt from '@/components/company/v2/authenticationmt.vue'
import dealerh5mt45 from '@/components/company/v2/dealer-h5-mt45.vue'
import companyBasic from '@/components/company/v2/companyBasic.vue'
import dealerctradeMt from '@/components/company/v2/dealerctradeMt.vue'
import { HexToRGB } from '~/utils/utils.js'
export default {
  name: 'SoftwareV2',
  components: {
    dealerMt,
    dealerctradeMt,
    individuaidentification,
    'authen-ticationmt': authenticationmt,
    'dealer-h5mt': dealerh5mt45,
    companyBasic,
    wikiImg: () => import('~/components/common/wikiImg/index.vue'),
    dealerctradeSoftware: () => import('~/components/company/v2/dealerctradeSoftware.vue')
  },
  inject: ['detail', 'softResult', 'softwareList'],
  data() {
    return {
      headData: this.detail?.main,
      isTwoLine: false,
      softval: {},
      bodywidth: 0,
      softCount: 0,
      updateDate: '',
      showsoftData: [],
      isSoftLeftRoll: true,
      isSoftRightRoll: false,
      isSoftwareSideLeft: false,
      isSoftwareSideRight: false,
      isSoftwareScrolledToLeft: false,
      isSoftwareScrolledToRight: false,
      tabsoftshow: false,
      isSideLeft: false,
      isRightRoll: false,
      isLeftRoll: true,
      isSideRight: false,
      isScrolledToRight: false,
      isScrolledToLeft: false,
      isIpDialog: false, // ip 弹框
      serverTabList: [],
      serverDataList: [],
      allServersData: [],
      mt4ServersData: [],
      mt5ServersData: [],
      serverIPObj: {}, // ip 弹框list数据
      companyBasic: {},
      ismtipd: false,
      leverDataList: [],
      isLeverPop: false,
      ctraderSoftwareList: [],
      selfSoftwareList: [],
      iosSelfSoftwareList: [],
      androidSelfSoftwareList: [],
      iosCtraderSoftwareList: [],
      androidCtraderSoftwareList: [],
      ctradeDataList: [],
      selfSoftwareDataList: [],
      activeTabIndex: 0,
      activeAppTabIndex: 0,
      // 软件2.0
      iscTradeLeft: false,
      iscTradeRight: false,
      isAppLeft: false,
      isAppLeftRoll: true,
      isAppRight: false,
      isAppRightRoll: false,
      softwareValType: 1,
      curInexImg: '',
      isBgShow: false,
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      zeroMultipleLeft: false,
      zeroMultipleRight: false
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    },
    tabs() {
      const tabList = []
      // 只有当 iosApps 和 androidApps 都有数据时，才添加 全部应用、 iOS 和 Android 标签
      if (this.iosCtraderSoftwareList.length > 0 && this.androidCtraderSoftwareList.length > 0) {
        tabList.push({ name: '全部应用', count: this.ctraderSoftwareList.length })
        tabList.push({ name: 'iOS', count: this.iosCtraderSoftwareList.length })
        tabList.push({ name: 'Android', count: this.androidCtraderSoftwareList.length })
      } else if (this.iosCtraderSoftwareList.length > 0 || this.androidCtraderSoftwareList.length > 0) {
        tabList.push({
          name: this.iosCtraderSoftwareList.length > 0 ? 'iOS' : 'Android',
          count: this.iosCtraderSoftwareList.length || this.androidCtraderSoftwareList.length
        })
      }
      return tabList
    },
    // 交易应用动态生成标签页，只有当 iosApps 和 androidApps 都有数据时才显示
    selfTabs() {
      const tabList = []
      // 只有当 iosApps 和 androidApps 都有数据时，才添加 全部应用、 iOS 和 Android 标签
      if (this.iosSelfSoftwareList.length > 0 && this.androidSelfSoftwareList.length > 0) {
        tabList.push({ name: '全部应用', count: this.selfSoftwareList.length })
        tabList.push({ name: 'iOS', count: this.iosSelfSoftwareList.length })
        tabList.push({ name: 'Android', count: this.androidSelfSoftwareList.length })
      } else if (this.iosSelfSoftwareList.length > 0 || this.androidSelfSoftwareList.length > 0) {
        tabList.push({
          name: this.iosSelfSoftwareList.length > 0 ? 'iOS' : 'Android',
          count: this.iosSelfSoftwareList.length || this.androidSelfSoftwareList.length
        })
      }
      return tabList
    }
  },
  watch: {},
  created() {
    this.ctraderSoftwareList = this.softwareList?.cTraderSoftware?.items || []
    this.selfSoftwareList = this.softwareList?.selfDevelopSoftware?.items || []
    this.ctradeDataList = this.ctraderSoftwareList
    this.selfSoftwareDataList = this.selfSoftwareList
    this.iosSelfSoftwareList = this.selfSoftwareList.filter((item) => item.marketId === 1)
    this.androidSelfSoftwareList = this.selfSoftwareList.filter((item) => item.marketId == 11)
    this.iosCtraderSoftwareList = this.ctraderSoftwareList.filter((item) => item.marketId === 1)
    this.androidCtraderSoftwareList = this.ctraderSoftwareList.filter((item) => item.marketId == 11)
  },
  mounted() {
    console.log('headData', this.headData)
    console.log(this.softResult?.items, '1111')
    window?.addEventListener('resize', this.screenFn)
    this.allServersData = this.softwareList?.serverList?.allServers || []
    this.mt4ServersData = this.softwareList?.serverList?.mT4Servers || []
    this.mt5ServersData = this.softwareList?.serverList?.mT5Servers || []
    this.serverDataList = this.allServersData
    setTimeout(() => {
      this.$refs.countrywid &&
        this.$refs.countrywid.forEach((item, ind) => {
          if (item.clientWidth >= 117.9) this.serverDataList[ind].widmax = true
          else this.serverDataList[ind].widmax = false
        })
    }, 100)

    setTimeout(() => {
      this.slideHidden()
      this.softSlideHidden()
      this.ctslideHidden()
      this.setTagStyle()
    }, 200)
    console.log(this.softResult, 'softResult')
    // 整理tab 数据
    if (this.softwareList?.serverList?.allServers?.length) {
      this.serverTabList.push({
        isActive: true,
        name: '全部服务器',
        tebType: 'all'
      })
    }
    if (this.softwareList?.serverList?.mT4Servers?.length) {
      this.serverTabList.push({
        isActive: false,
        name: 'MT4',
        tebType: 'mt4'
      })
    }
    if (this.softwareList?.serverList?.mT5Servers?.length) {
      this.serverTabList.push({
        isActive: false,
        name: 'MT5',
        tebType: 'mt5'
      })
    }

    this.bodywidth = document && document.documentElement && document.documentElement.clientWidth
    if (this.bodywidth > 1199 && this.softwareList?.mt45Software?.length > 4) {
      this.tabsoftshow = true
      this.showsoftData = this.softwareList?.mt45Software?.slice(0, 4)
    } else {
      this.showsoftData = this.softwareList?.mt45Software || []
    }

    console.log(this.showsoftData, '相关软件数据...')
    window.addEventListener('resize', () => {
      this.setTagStyle()
      this.bodywidth = document && document.documentElement && document.documentElement.clientWidth
      if (this.bodywidth > 1199 && this.softwareList?.mt45Software?.length > 4) {
        this.tabsoftshow = true
        this.showsoftData = this.softwareList?.mt45Software?.slice(0, 4)
      } else {
        this.showsoftData = this.softwareList?.mt45Software || []
      }
    })
    console.log('serverDataList', this.serverDataList)
    console.log('softResult', this.softResult)
  },
  methods: {
    leverPopClick(item) {
      if (!item || !item.leverage) {
        return
      }
      this.leverDataList = item.leverageDetailList
      this.isLeverPop = true
    },
    openauthenticat() {
      if (this.$store.state.mobile) {
        this.$nextTick(() => {
          this.$refs.h5mtDom.showMt()
        })
      } else {
        this.$refs.authenticat.show()
      }
    },
    ipclone() {
      // console.log('弹框关闭');
      const ele = document.querySelector('.only-outer-border')
      if (ele?.length > 0) {
        ele.scrollTop = 0
      }

      // console.log('document.querySelecto ', document.querySelector('.only-outer-border'));
      // console.log('document.querySelecto ', document.querySelector('.only-outer-border'));
      if (!this.ismtipd) document.body.style.overflow = 'auto'
    },
    openIpDialog(item) {
      console.log('触发3', item)
      this.ismtipd = false
      console.log(item, 8886)
      if (item?.serverIPList?.list?.length) {
        this.serverIPObj = item.serverIPList
        this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
        document.body.style.setProperty('overflow', 'hidden', 'important')
        this.isIpDialog = true
      }
      this.companyBasic = item.companyBasic
    },
    pingIcon(i) {
      if (i == 1) return 'https://resources1.interface003.com/web20/img/commen/green.gif'
      else if (i == 2) return 'https://resources1.interface003.com/web20/img/commen/yellow.gif'
      else if (i == 3) return 'https://resources1.interface003.com/web20/img/commen/red.gif'
      else return 'https://resources1.interface003.com/web20/img/commen/red.gif'
    },
    setTagStyle() {
      setTimeout(() => {
        this.$refs.tagDom.forEach((item) => {
          if (item.clientHeight > 35) {
            this.isTwoLine = true
          } else {
            this.isTwoLine = false
          }
        })
      }, 200)
    },
    openmt(item) {
      // 数据做了拆分 带有 appBundleId 数据不存在了 先进行注释（变化无常）
      // if (item.appBundleId) {
      //   const code = this.$route.params.id && this.$route.params.id.split('.')[0]
      //   const codeParams = item.marketId + '-' + item.appBundleId + '-' + code + '-' + (item.marketId == 11 ? 2 : 1)
      //   window.open(`/${this.$store.state.LanguageCode}/softwareDetails/${codeParams}.html`)
      //   return
      // }
      // 打开相关软件弹框
      console.log(item, 9999)

      for (const key in item) {
        this.$set(this.softval, key, item[key])
      }
      console.log('softval-open', this.softval)
      if (item.softwareType != 3 && item.softwareType != 4) {
        if (this.$store.state.mobile) {
          this.$nextTick(() => {
            this.$refs.h5mtDom.showMt(item)
          })
        } else {
          this.$refs.individuaident.open()
        }
      } else if (item.softwareType == 3)
        this.$refs.dealerctradeMt.open() // ctrade弹框
      else {
        this.$refs.dealerMt.open()
      }
    },
    pre() {
      if (this.softCount <= 0) {
        return
      }
      this.softCount--
      const left = `-${Number(this.softCount * 173)}px`
      document.getElementById('sd-tab-position').style.transform = `translateX(${left})`
    },
    next() {
      if (this.softCount >= this.softwareList?.mt45Software?.length - 4) {
        return
      }
      this.softCount++
      const left = `-${Number(this.softCount * 173)}px`
      document.getElementById('sd-tab-position').style.transform = `translateX(${left})`
    },
    serviceTabClick(itemClick, i) {
      const _this = this
      _this.serverTabList.forEach((item, index) => {
        if (index == i) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
      if (itemClick.tebType == 'all') {
        _this.serverDataList = _this.allServersData
      } else if (itemClick.tebType == 'mt4') {
        _this.serverDataList = _this.mt4ServersData
      } else if (itemClick.tebType == 'mt5') {
        _this.serverDataList = _this.mt5ServersData
      }
      setTimeout(() => {
        this.slideHidden()
        this.$refs.countrywid &&
          this.$refs.countrywid.forEach((item, ind) => {
            if (item.clientWidth >= 117.9) this.serverDataList[ind].widmax = true
            else this.serverDataList[ind].widmax = false
          })
        this.$forceUpdate()
      }, 200)
      this.$refs.wrapperCon.style.transition = 'transform 0.3s'
      this.$refs.wrapperCon.scrollLeft = '0px'
    },
    // 服务器数据右滑事件
    rightSlide() {
      let left = this.$refs.wrapperCon.scrollLeft
      // 保存元素的整体宽度
      const scrollWidth = this.$refs.wrapperCon.scrollWidth
      // 保存元素的可见宽度
      const clientWidth = this.$refs.wrapperCon.clientWidth
      console.log('clientWidth', clientWidth)
      // 获取当前元素的宽度
      // const itemWidth = this.$refs.warpItem[0].clientWidth
      let pointNum = null
      let integerNum = null
      const onceNum = clientWidth / 10
      if (String(onceNum).indexOf('.') >= 1) {
        const parts = String(onceNum).split('.')
        pointNum = Number(parts[1])
        integerNum = Number(parts[0])
      } else {
        integerNum = onceNum
      }
      console.log(clientWidth, 'itemWidth')
      let num = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=itemWidth一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= clientWidth - pointNum) {
          clearInterval(this.timer)
          this.$refs.wrapperCon.scrollLeft = this.$refs.wrapperCon.scrollLeft + 12 + pointNum
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft = left += integerNum
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += integerNum
      }, 20)
      // this.isSideLeft = true
    },
    // 服务器数据 点击左滑
    leftSlide() {
      let left = this.$refs.wrapperCon.scrollLeft
      let num = 0
      // 保存元素的可见宽度
      const clientWidth = this.$refs.wrapperCon.clientWidth
      //  const itemWidth = this.$refs.warpItem[0].clientWidth
      let pointNum = null
      let integerNum = null
      const onceNum = clientWidth / 10
      if (String(onceNum).indexOf('.') >= 1) {
        const parts = String(onceNum).split('.')
        pointNum = Number(parts[1])
        integerNum = Number(parts[0])
      } else {
        integerNum = onceNum
      }
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        //   !left:已经滚动到最左侧
        //   一次性滚动距离（可调节）
        if (!left || num >= clientWidth - pointNum) {
          // 停止滚动
          clearInterval(this.timer)
          this.$refs.wrapperCon.scrollLeft = this.$refs.wrapperCon.scrollLeft - (12 + pointNum)
          this.timer = null
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft = left -= integerNum
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += integerNum
      }, 20)
    },
    // 相关软件控制是否隐藏
    softSlideHidden() {
      const tempWidth = this.$refs.warpSoftItem && this.$refs.warpSoftItem[0].clientWidth * this.softwareList?.mt45Software?.length
      if (tempWidth > this.$refs?.entiretySoftItem?.clientWidth) {
        this.isSoftwareSideRight = true
        this.isSoftwareSideLeft = true
      } else {
        this.isSoftwareSideRight = false
        this.isSoftwareSideLeft = false
      }
    },
    // 控制服务数据 左右切换是否隐藏
    slideHidden() {
      const tempWidth = this.$refs?.warpItem && this.$refs?.warpItem[0]?.clientWidth * this.serverDataList?.length
      if (tempWidth > this.$refs?.entiretyItem?.clientWidth) {
        this.isSideRight = true
        this.isSideLeft = true
      } else {
        this.isSideRight = false
        this.isSideLeft = false
      }
    },
    // 服务商数据滚动事件
    handleScroll(event) {
      const container = event.target
      // 检查是否滚动到最右边
      //  this.isScrolledToRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1;
      // 检查是否滚动到最左边
      //  this.isScrolledToLeft = container.scrollLeft === 0;
      // console.log(container.scrollLeft, 'container.scrollLeft');
      const isRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1
      if (isRight) {
        this.isRightRoll = true
      } else {
        this.isRightRoll = false
      }
      if (container.scrollLeft === 0) {
        this.isLeftRoll = true
      } else {
        this.isLeftRoll = false
      }
    },

    // 相关软件数据 右滑事件
    rightSoftSlide() {
      let left = this.$refs.wrapperSoftCon.scrollLeft
      // 保存元素的整体宽度
      const scrollWidth = this.$refs.wrapperSoftCon.scrollWidth
      // 保存元素的可见宽度
      const clientWidth = this.$refs.wrapperSoftCon.clientWidth
      // 获取当前元素的宽度
      const itemWidth = this.$refs.warpSoftItem[0].clientWidth
      let pointNum = null
      let integerNum = null
      const onceNum = itemWidth / 10
      if (String(onceNum).indexOf('.') >= 1) {
        const parts = String(onceNum).split('.')
        pointNum = Number(parts[1])
        integerNum = Number(parts[0])
      } else {
        integerNum = onceNum
      }
      let num = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=itemWidth一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= itemWidth - pointNum) {
          clearInterval(this.timer)
          this.$refs.wrapperSoftCon.scrollLeft = this.$refs.wrapperSoftCon.scrollLeft + 12 + pointNum
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperSoftCon.scrollLeft = left += integerNum
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += integerNum
      }, 20)
      // this.isSoftwareSideLeft = true
    },
    // 相关软件数据 左滑事件
    leftSoftSlide() {
      let left = this.$refs.wrapperSoftCon.scrollLeft
      let num = 0
      const itemWidth = this.$refs.warpSoftItem[0].clientWidth
      let pointNum = null
      let integerNum = null
      const onceNum = itemWidth / 10
      if (String(onceNum).indexOf('.') >= 1) {
        const parts = String(onceNum).split('.')
        pointNum = Number(parts[1])
        integerNum = Number(parts[0])
      } else {
        integerNum = onceNum
      }
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        //   !left:已经滚动到最左侧
        //   一次性滚动距离（可调节）
        if (!left || num >= itemWidth - pointNum) {
          // 停止滚动
          clearInterval(this.timer)
          this.$refs.wrapperSoftCon.scrollLeft = this.$refs.wrapperSoftCon.scrollLeft - (12 + pointNum)
          this.timer = null
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperSoftCon.scrollLeft = left -= integerNum
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += integerNum
      }, 20)
    },
    // 软件滚动事件
    handleSoftScroll(event) {
      const container = event.target
      // 检查是否滚动到最右边
      //  this.isSoftwareScrolledToRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1;
      // 检查是否滚动到最左边
      //  this.isSoftwareScrolledToLeft = container.scrollLeft === 0;
      const isRight = container.scrollWidth - container.clientWidth - container.scrollLeft <= 1
      if (isRight) {
        this.isSoftRightRoll = true
      } else {
        this.isSoftRightRoll = false
      }
      if (container.scrollLeft === 0) {
        this.isSoftLeftRoll = true
      } else {
        this.isSoftLeftRoll = false
      }
    },
    openmtIpDialog(item) {
      console.log(item, 8886)
      this.ismtipd = true
      this.companyBasic = item?.companyBasic
      if (item?.serverIPList?.list?.length) {
        this.serverIPObj = item?.serverIPList
        this.updateDate = dayjs(new Date(Number(this.serverIPObj.updateDate))).format('YYYY-MM-DD')
        document.body.style.setProperty('overflow', 'hidden', 'important')
        this.isIpDialog = true
      }
    },
    TransColor(color, tm) {
      if (!color) {
        return ''
      } else {
        return HexToRGB(color, tm)
      }
    },
    //  ------ 添加相关软件 2.0 逻辑 -----
    // cTrater 弹框事件
    ctraderAppPopup(val) {
      this.softwareValType = val
      this.$refs.ctradeSoftware.open()
    },
    // 左滑事件
    appLeftSlide(val) {
      // 添加防抖 - 清除现有计时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        let left = val === 1 ? this.$refs.cTradeCon.scrollLeft : this.$refs.selfSoftICon.scrollLeft
        let num = 0
        const itemWidth = val === 1 ? this.$refs.cTradeItem[0].clientWidth : this.$refs.selfSoftItem[0].clientWidth
        let pointNum = null
        let integerNum = null
        const onceNum = itemWidth / 10
        if (String(onceNum).indexOf('.') >= 1) {
          const parts = String(onceNum).split('.')
          pointNum = Number(parts[1])
          integerNum = Number(parts[0])
        } else {
          integerNum = onceNum
        }
        clearInterval(this.timer)
        this.timer = null
        this.timer = setInterval(() => {
          //   !left:已经滚动到最左侧
          //   一次性滚动距离（可调节）
          if (!left || num >= itemWidth - pointNum) {
            // 停止滚动
            clearInterval(this.timer)
            if (val === 1) {
              this.$refs.cTradeCon.scrollLeft = this.$refs.cTradeCon.scrollLeft - (12 + pointNum)
            } else {
              this.$refs.selfSoftICon.scrollLeft = this.$refs.selfSoftICon.scrollLeft - (12 + pointNum)
            }
            this.timer = null
            return
          }
          // 给滚动盒子元素赋值向左滚动距离
          if (val === 1) {
            this.$refs.cTradeCon.scrollLeft = left -= integerNum
          } else {
            this.$refs.selfSoftICon.scrollLeft = left -= integerNum
          }
          // 保存向左滚动距离（方便判断一次性滚动多少距离）
          num += integerNum
        }, 20)
      }, 200) // 300ms 防抖延迟，可以根据需要调整
    },
    //  右滑事件
    appRightSlide(val) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        let left = val === 1 ? this.$refs.cTradeCon.scrollLeft : this.$refs.selfSoftICon.scrollLeft
        // 保存元素的整体宽度
        const scrollWidth = val === 1 ? this.$refs.cTradeCon.scrollWidth : this.$refs.selfSoftICon.scrollWidth
        // 保存元素的可见宽度
        const clientWidth = val === 1 ? this.$refs.cTradeCon.clientWidth : this.$refs.selfSoftICon.clientWidth
        // 获取当前元素的宽度
        const itemWidth = val === 1 ? this.$refs.cTradeItem[0].clientWidth : this.$refs.selfSoftItem[0].clientWidth
        let pointNum = null
        let integerNum = null
        const onceNum = itemWidth / 10
        if (String(onceNum).indexOf('.') >= 1) {
          const parts = String(onceNum).split('.')
          pointNum = Number(parts[1])
          integerNum = Number(parts[0])
        } else {
          integerNum = onceNum
        }
        let num = 0

        // 取消之前的动画帧（如果有）
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId)
        }

        // 使用requestAnimationFrame替代setInterval
        const startTime = performance.now()
        const animate = (currentTime) => {
          const elapsed = currentTime - startTime
          const progress = Math.min(elapsed / 400, 1) // 400ms动画时间

          // 已经滚动距离+可见宽度
          // left+clientWidth>=scrollWidth：滚动到最右侧
          // num>=itemWidth一次性滚动距离
          if (left + clientWidth >= scrollWidth || num >= itemWidth - pointNum) {
            if (val === 1) {
              this.$refs.cTradeCon.scrollLeft = this.$refs.cTradeCon.scrollLeft + 12 + pointNum
            } else {
              this.$refs.selfSoftICon.scrollLeft = this.$refs.selfSoftICon.scrollLeft + 12 + pointNum
            }
            return
          }

          // 给滚动盒子元素赋值向左滚动距离
          if (val === 1) {
            this.$refs.cTradeCon.scrollLeft = left += integerNum
          } else {
            this.$refs.selfSoftICon.scrollLeft = left += integerNum
          }
          // 保存向左滚动距离（方便判断一次性滚动多少距离）
          num += integerNum

          if (progress < 1) {
            this.animationFrameId = requestAnimationFrame(animate)
          }
        }

        this.animationFrameId = requestAnimationFrame(animate)
      }, 200)
    },

    // 控制cTrader 和 交易应用 左右切换是否隐藏
    ctslideHidden() {
      const tempList = this.ctradeDataList.length > 0 ? this.ctradeDataList : this.selfSoftwareDataList
      const tempWidth = this.$refs?.selfSoftItem && this.$refs?.selfSoftItem[0]?.clientWidth * tempList.length
      if (tempWidth > this.$refs?.softwareAll?.clientWidth) {
        this.zeroMultipleRight = true
        this.zeroMultipleLeft = true
      } else {
        this.zeroMultipleRight = false
        this.zeroMultipleLeft = false
      }
    },

    // 查看大图事件
    lookBigImg(val, item, type) {
      if (type === 2) {
        const codeParams = item?.marketId + '-' + item?.appBundleId + '-' + this.headData.traderCode + '-' + item?.showPlatform
        this.matomofn('af_Broker_App', { name: item?.name, codeParams })
      }
      this.isBgShow = true
      this.curInexImg = val
    },
    //  跳转到软件详情
    detailsClick(v, item, type) {
      const code = this.$route.params.id && this.$route.params.id.split('.')[0]
      // 拖动的时候 偶尔会触发外层的点击事件 加个属性进行控制
      if (this.isDragging) {
        return
      }
      const codeParams = item.marketId + '-' + item.appBundleId + '-' + code + '-' + item.showPlatform
      if (type === 2) {
        this.matomofn('af_Broker_App', { name: item?.name, codeParams })
      }
      window.open(`/${this.$store.state.LanguageCode}/softwareDetails/${codeParams}.html?fromType=1`)
    },

    // 鼠标事件处理
    startDrag(e, index, val) {
      this.isDragging = true
      if (val === 1) {
        this.startX = e.pageX - this.$refs.scrollcTraderContainer[index].offsetLeft
        this.scrollLeft = this.$refs.scrollcTraderContainer[index].scrollLeft
        this.$refs.scrollcTraderContainer[0].style.cursor = 'grabbing'
      }
      if (val === 2) {
        this.startX = e.pageX - this.$refs.scrollContainer[index].offsetLeft
        this.scrollLeft = this.$refs.scrollContainer[index].scrollLeft
        this.$refs.scrollContainer[0].style.cursor = 'grabbing'
      }
      if (val === 3) {
        this.startX = e.pageX - this.$refs.scrollThreeContainer.offsetLeft
        this.scrollLeft = this.$refs.scrollThreeContainer.scrollLeft
        this.$refs.scrollThreeContainer.style.cursor = 'grabbing'
      }
      if (val === 4) {
        this.startX = e.pageX - this.$refs.scrollFourContainer[index].offsetLeft
        this.scrollLeft = this.$refs.scrollFourContainer[index].scrollLeft
        this.$refs.scrollFourContainer[0].style.cursor = 'grabbing'
      }
      e.stopPropagation()
      // 防止选中文本
      e.preventDefault()
    },
    stopDrag(e, index, val) {
      // 拖动结束逻辑
      setTimeout(() => {
        this.isDragging = false
      }, 50)
      if (val === 1) {
        this.$refs.scrollcTraderContainer[index].style.cursor = 'grab'
      }
      if (val === 2) {
        this.$refs.scrollContainer[index].style.cursor = 'grab'
      }
      if (val === 3) {
        this.$refs.scrollThreeContainer.style.cursor = 'grab'
      }
      if (val === 4) {
        this.$refs.scrollFourContainer[index].style.cursor = 'grab'
      }
    },
    onDrag(e, index, val) {
      if (!this.isDragging) return
      if (val === 1) {
        const x = e.pageX - this.$refs.scrollcTraderContainer[index].offsetLeft
        const walk = (x - this.startX) * 2 // 滚动速度系数
        this.$refs.scrollcTraderContainer[index].scrollLeft = this.scrollLeft - walk
      }
      if (val === 2) {
        const x = e.pageX - this.$refs.scrollContainer[index].offsetLeft
        const walk = (x - this.startX) * 2 // 滚动速度系数
        this.$refs.scrollContainer[index].scrollLeft = this.scrollLeft - walk
      }
      if (val === 3) {
        const x = e.pageX - this.$refs.scrollThreeContainer.offsetLeft
        const walk = (x - this.startX) * 2 // 滚动速度系数
        this.$refs.scrollThreeContainer.scrollLeft = this.scrollLeft - walk
      }
      if (val === 4) {
        const x = e.pageX - this.$refs.scrollFourContainer[index].offsetLeft
        const walk = (x - this.startX) * 2 // 滚动速度系数
        this.$refs.scrollFourContainer[index].scrollLeft = this.scrollLeft - walk
      }
      // 拖拽时阻止事件冒泡
      e.stopPropagation()
      e.preventDefault()
    },
    // 触摸事件处理
    startDragTouch(e, index, val) {
      this.isDragging = true
      if (val === 1) {
        this.startX = e.touches[0].pageX - this.$refs.scrollcTraderContainer[index].offsetLeft
        this.scrollLeft = this.$refs.scrollcTraderContainer[index].scrollLeft
      }
      if (val === 2) {
        this.startX = e.touches[0].pageX - this.$refs.scrollContainer[index].offsetLeft
        this.scrollLeft = this.$refs.scrollContainer[index].scrollLeft
      }
      if (val === 3) {
        this.startX = e.touches[0].pageX - this.$refs.scrollThreeContainer.offsetLeft
        this.scrollLeft = this.$refs.scrollThreeContainer.scrollLeft
      }
      if (val === 4) {
        this.startX = e.touches[0].pageX - this.$refs.scrollFourContainer[index].offsetLeft
        this.scrollLeft = this.$refs.scrollFourContainer[index].scrollLeft
      }
      this.dragDistance = 0
      e.stopPropagation()
    },
    onDragTouch(e, index, val) {
      if (!this.isDragging) return
      if (val === 1) {
        const x = e.touches[0].pageX - this.$refs.scrollcTraderContainer[index].offsetLeft
        const walk = (x - this.startX) * 2
        this.dragDistance += Math.abs(walk) // 累计拖拽距离
        this.$refs.scrollcTraderContainer[index].scrollLeft = this.scrollLeft - walk
      }
      if (val === 2) {
        const x = e.touches[0].pageX - this.$refs.scrollContainer[index].offsetLeft
        const walk = (x - this.startX) * 2
        this.dragDistance += Math.abs(walk) // 累计拖拽距离
        this.$refs.scrollContainer[index].scrollLeft = this.scrollLeft - walk
      }
      if (val === 3) {
        const x = e.touches[0].pageX - this.$refs.scrollThreeContainer.offsetLeft
        const walk = (x - this.startX) * 2
        this.dragDistance += Math.abs(walk) // 累计拖拽距离
        this.$refs.scrollThreeContainer.scrollLeft = this.scrollLeft - walk
      }
      if (val === 4) {
        const x = e.touches[0].pageX - this.$refs.scrollFourContainer[index].offsetLeft
        const walk = (x - this.startX) * 2
        this.dragDistance += Math.abs(walk) // 累计拖拽距离
        this.$refs.scrollFourContainer[index].scrollLeft = this.scrollLeft - walk
      }
      e.stopPropagation()
      e.preventDefault()
    },

    handleContainerClick(event) {
      event.stopPropagation() // 阻止冒泡到外层
    },
    // tab 切换事件
    tabsitemClick(index, val, type) {
      // 1. 语义化常量定义（替代魔法数字，便于维护）
      const TAB_TYPE = {
        CT: 1, // ct 类型
        TRADE_APP: 2 // 交易应用类型
      }
      // 2. 定义 DOM 滚动配置映射（统一管理滚动相关的 refs 和逻辑）
      const scrollConfigMap = {
        [TAB_TYPE.CT]: { ref: 'cTradeCon' },
        [TAB_TYPE.TRADE_APP]: { ref: 'selfSoftICon' }
      }
      // 3. 定义数据映射表（替代 switch-case，扩展性极强）
      const dataSourceMap = {
        0: {
          [TAB_TYPE.CT]: this.ctraderSoftwareList,
          [TAB_TYPE.TRADE_APP]: this.selfSoftwareList
        },
        1: {
          [TAB_TYPE.CT]: this.iosCtraderSoftwareList,
          [TAB_TYPE.TRADE_APP]: this.iosSelfSoftwareList
        },
        2: {
          [TAB_TYPE.CT]: this.androidCtraderSoftwareList,
          [TAB_TYPE.TRADE_APP]: this.androidSelfSoftwareList
        }
      }

      // 4. 第一步：更新激活的 Tab 索引（简化 if-else）
      if (val === TAB_TYPE.CT) {
        this.activeTabIndex = index
      } else {
        this.activeAppTabIndex = index
      }

      // 5. 第二步：根据 Tab 类型和索引，赋值对应数据
      // 获取当前激活的索引（区分 CT/交易应用）
      const activeIndex = val === TAB_TYPE.CT ? this.activeTabIndex : this.activeAppTabIndex
      // 获取目标数据源（兜底默认值，避免索引超出范围）
      const targetDataSource = dataSourceMap[activeIndex] || dataSourceMap[0]
      // 赋值数据（根据类型匹配）
      if (val === TAB_TYPE.CT) {
        this.ctradeDataList = targetDataSource[TAB_TYPE.CT]
      } else {
        this.selfSoftwareDataList = targetDataSource[TAB_TYPE.TRADE_APP]
      }

      // 6. 第三步：重置滚动位置和相关状态标志（完整的状态重置）
      const { ref: scrollRefName } = scrollConfigMap[val]
      const scrollRef = this.$refs[scrollRefName]
      if (scrollRef) {
        scrollRef.style.transition = 'transform 0.3s'
        scrollRef.scrollLeft = 0 // 数字类型更规范，无需加 px

        // 根据Tab类型重置相应的滚动状态标志
        if (val === TAB_TYPE.CT) {
          this.isLeftRoll = true // 重置为已滚动到最左边
          this.isRightRoll = false // 重置为未滚动到最右边
          this.iscTradeLeft = false // 确保iscTradeLeft也被重置
        } else {
          this.isAppLeftRoll = true
          this.isAppRightRoll = false
        }
      }
      if (type === 'oneType') {
        this.$nextTick(() => {
          this.ctslideHidden()
        })
      }
    }
  }
}
